import type { ThemePayload } from "../schemas/Theme";
import { themeCustomButtonBackground } from "./themeCustomButtonBackground";
import { themeCustomButtonText } from "./themeCustomButtonText";

export function themeCustomButtonObject(theme: ThemePayload) {
  return theme.buttonHexColor
    ? {
        "--litesite-custom-button-background": themeCustomButtonBackground(theme),
        "--litesite-custom-button-text": themeCustomButtonText(theme),
      }
    : {};
}
